<template lang="pug">
v-container(fluid fill-height class=" ")
  div(class="d-flex flex-column tw-h-full tw-w-full")
    div(class=" tw-flex tw-flex-row tw-flex-grow-0  pt-2 tw-pb-8 tw-text-left")
      v-row
        v-col
          span(class="tw-text-2xl text-secondary tw-font-bold") {{ $t('Website.Common.pagesSettingsHeading') }}
    div(class="d-flex flex-row flex-grow-1 full-width")
      v-form(ref="form" v-model="valid" lazy-validation class="tw-w-full")
        v-row(class="d-flex flex-row tw-w-full flex-grow-1 ")
          v-col(class="fill-height my-0 py-0 ")
            v-tabs(vertical class="py-0 my-0")
              v-tab
                span {{ $t('Website.Common.home') }}
              v-tab
                span {{ $t('Website.Common.rent') }}
              v-tab
                span {{ $t('Website.Common.sell') }}
              v-tab
                span {{ $t('Website.Common.about') }}
              v-tab
                span {{ $t('Website.Common.contact') }}

              v-tab-item(transition="v-slide-y-transition" class="fill-height")
                v-row(class="pl-3")
                  v-col
                    kubiqa-website-shared-page-options(:page="website.pages.home")
              v-tab-item(transition="v-slide-y-transition" class="fill-height")
                v-row(class="pl-3")
                  v-col
                    kubiqa-website-shared-page-options(:page="website.pages.rent")
              v-tab-item(transition="v-slide-y-transition" class="fill-height")
                v-row(class="pl-3")
                  v-col
                    kubiqa-website-shared-page-options(:page="website.pages.buy")
              v-tab-item(transition="v-slide-y-transition" class="fill-height")
                v-row(class="pl-3")
                  v-col
                    kubiqa-website-shared-page-options(:page="website.pages.about")
              v-tab-item(transition="v-slide-y-transition" class="fill-height")
                v-row(class="pl-3")
                  v-col
                    kubiqa-website-shared-page-options(:page="website.pages.contact")
    div(class="d-flex flex-row flex-grow-0 full-width")
      v-row(justify="end" align-self="end" align="end" class="tw-bottom-0")
        v-col(cols="auto" align-end class="tw-h-full fill-height")
          v-btn(@click="$emit('close')" text :ripple="false")
            span(class=" tw-text-kPurple tw-mt-4") {{ $t('Common.cancel') }}
          v-btn(depressed color="rgba(94,129,244,0.80)" :loading="loading" @click="save")
            span(class="tw-font-bold") {{ $t('Common.save') }}
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      website: {},
      valid: true,
    };
  },
  mounted() {
    this.website = JSON.parse(JSON.stringify(this.$store.getters['website/website']));
  },
  methods: {
    save() {
      if (this.$refs.form.validate() === false) return;
      this.loading = true;
      this.$store
        .dispatch('website/updatePages', this.website.pages)
        .then((response) => {
          this.$emit('close');
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log(error);
        });
    },
  },
};
</script>
